import React from 'react'
import { connect } from 'react-redux'
import * as actions from '../../../actions'
import { EventRegister } from '../components'
import { Word } from '../../../containers'
import * as api from '../../../actions/api'
import { deepCopy } from '../../../lib'
import moment from 'moment'
import { WID } from '../../../constants/Language';
import { EVENT_REGISTER_RESULT } from '../../../constants'

const mapStateToProps = (state, ownProps) => {
  const { width } = state.window
  const { googleMap } = state.api
  const { record, authorType, name, thumbnail, address, latitude, longitude, addressComponents, startDate, startTime, endDate, endTime, detail, checkedEndDatetime } = state.eventRegister
  const { language } = state.user
  var now, startDateTime, endDateTime, error, disabledRegisterButton, oneYearLater, update, eventId
  
  eventId = ownProps.match.params.eventId
  update = Boolean(eventId !== undefined)
  startDateTime = moment({
    year: startDate.year(),
    month: startDate.month(),
    date: startDate.date(),
    hour: startTime !== null ? startTime.hour() : 0,
    minute: startTime !== null ? startTime.minute() : 0,
  })
  endDateTime = endDate !== null ? moment({
    year: endDate.year(),
    month: endDate.month(),
    date: endDate.date(),
    hour: endTime !== null ? endTime.hour() : 0,
    minute: endTime !== null ? endTime.minute() : 0,
  }) : undefined
  error = {}
  now = Date.now()
  oneYearLater = new Date()
  oneYearLater.setYear(oneYearLater.getFullYear() + 1)
  
  disabledRegisterButton = true
  
  if (startDateTime.valueOf() < now) {
    error.startDateTime = <Word wid={WID.EVENT_REGISTER_CARD.ERROR_START_DATETIME1}/>
  }
  if (startDateTime.valueOf() > oneYearLater.getTime()) {
    error.startDateTime = <Word wid={WID.EVENT_REGISTER_CARD.ERROR_START_DATETIME2}/>
  }
  if (checkedEndDatetime && endDateTime !== undefined) {
    if (0 > endDateTime.valueOf() - startDateTime.valueOf()) {
      error.endDateTime = <Word wid={WID.EVENT_REGISTER_CARD.ERROR_END_DATETIME1}/>
    }
  }
  if (name.length > 0 && Object.keys(error).length === 0) {
    disabledRegisterButton = false
  }
  
  return ({
    width,
    update,
    eventRegisterCardSProps: {
      width, eventId, update, record, authorType, name, thumbnail, address, latitude, longitude, addressComponents, startDate, startTime, endDate, endTime, detail, checkedEndDatetime, error, disabledRegisterButton
    },
    googleMap,
    language
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    eventRegisterCardDProps: {
      init: () => {
        if (ownProps.match.params.eventId === undefined) {
          return
        }
        dispatch(api.event.select({ id: parseInt(ownProps.match.params.eventId, 10) }, (response) => {
          dispatch(actions.eventCard.responseSelect(response))
          if (response.result !== true || response.records.length !== 1) {
            dispatch(actions.snackbar.notify(<Word wid={WID.EVENT_REGISTER_CARD.SNACKBAR_FAILED_RECEIVE}/>, 'error'))
            return
          }
          dispatch(actions.eventRegister.responseSelectEvent(response))
        }))
      },
      handleChangedText: (name) => (event) => {
        dispatch(actions.eventRegister.changedText(name, event.target.value))
      },
      handleChangedDateTime: (name) => (value) => {
        dispatch(actions.eventRegister.changedDateTime(name, value))
      },
      handleChangedAddress: (address) => {
        dispatch(actions.eventRegister.changedText('address', address))
      },
      handleGeoCode: (geoCode) => {
        dispatch(actions.eventRegister.changedGeoCode(geoCode))
      },
      handleChangedLatLng: (latLng) => {
        dispatch(actions.eventRegister.changedLatLng(latLng))
      },
      handleChangedTinyMCE: (name) => (content) => {
        dispatch(actions.eventRegister.changedText(name, content))
      },
      handleChangePhoto: (name, data) => {
        dispatch(actions.eventRegister.changedPhoto(name, data))
      },
      handleDeletePhoto: (name) => {
        dispatch(actions.eventRegister.changedPhoto(name, ''))
      },
      handleChangedCheckButton: (name, check) => () => {
        dispatch(actions.eventRegister.changedCheckbox(name, check))
      },
      handleDeleteAddress: (event) => {
        dispatch(actions.eventRegister.deleteAddress())
      },
      handleRegister: (data, checkedEndDatetime) => {
        var startDateTime, endDateTime
        return new Promise((resolve, reject) => {
          if (data.thumbnail) {
            dispatch(api.media.upload(
              'thumbnail',
              '#thumbnailUrl',
              (response) => {
                if (response.result === true) {
                  resolve(response)
                }
                else {
                  reject('faild to upload thumbnail.')
                }
              }
            ))
          }
          else {
            resolve(null)
          }
        })
        .then(response => {
          delete data.thumbnail
          if (response !== null) {
            if (response.result === true) {
              data.thumbnail = response.photoURL
            }
            else {
              data.thumbnail = undefined
              dispatch(actions.snackbar.notify(<Word wid={WID.EVENT_REGISTER_CARD.SNACKBAR_FAILED_UPLOAD_THUMBNAIL}/>, 'error'))
            }
          }
          startDateTime = moment({
            year: data.startDate.year(),
            month: data.startDate.month(),
            date: data.startDate.date(),
            hour: data.startTime !== null ? data.startTime.hour() : 0,
            minute: data.startTime !== null ? data.startTime.minute() : 0,
          })
          data.startDate = moment([data.startDate.year(), data.startDate.month(), data.startDate.date()]).valueOf()
          data.startTime = data.startTime !== null ? startDateTime.valueOf() - data.startDate : undefined

          endDateTime = data.endDate !== null ? moment({
            year: data.endDate.year(),
            month: data.endDate.month(),
            date: data.endDate.date(),
            hour: data.endTime !== null ? data.endTime.hour() : 0,
            minute: data.endTime !== null ? data.endTime.minute() : 0,
          }) : undefined
          data.endDate = checkedEndDatetime && data.endDate !== null ?
            moment([data.endDate.year(), data.endDate.month(), data.endDate.date()]).valueOf() : undefined
          data.endTime = checkedEndDatetime && endDateTime && data.endTime !== null ?
            endDateTime.valueOf() - data.endDate : undefined

          data.authorType = parseInt(data.authorType, 10)
          return dispatch(api.event.add(data))
        })
        .then(response => {
          if (response.result === true) {
            dispatch(actions.eventRegister.responseAddEvent(response))
            dispatch(actions.snackbar.notify(<Word wid={WID.EVENT_REGISTER_CARD.SNACKBAR_SUCCESS_REGISTER}/>, 'info'))
            return Promise.resolve({ result: EVENT_REGISTER_RESULT.SUCCESS, eventId: response.id })
          }
          else {
            dispatch(actions.snackbar.notify(<Word wid={WID.EVENT_REGISTER_CARD.SNACKBAR_FAILED_REGISTER}/>, 'error'))
            return Promise.reject('error')
          }
        })
      },
      handleUpdate: (before, after, checkedEndDatetime) => {
        var data, startDateTime, endDateTime

        data = deepCopy(after)

        startDateTime = moment({
          year: data.startDate.year(),
          month: data.startDate.month(),
          date: data.startDate.date(),
          hour: data.startTime !== null ? data.startTime.hour() : 0,
          minute: data.startTime !== null ? data.startTime.minute() : 0,
        })
        data.startDate = moment([data.startDate.year(), data.startDate.month(), data.startDate.date()]).valueOf()
        data.startTime = data.startTime !== null ? startDateTime.valueOf() - data.startDate : undefined

        endDateTime = data.endDate !== null ? moment({
          year: data.endDate.year(),
          month: data.endDate.month(),
          date: data.endDate.date(),
          hour: data.endTime !== null ? data.endTime.hour() : 0,
          minute: data.endTime !== null ? data.endTime.minute() : 0,
        }) : undefined
        data.endDate = checkedEndDatetime && data.endDate !== null ?
          moment([data.endDate.year(), data.endDate.month(), data.endDate.date()]).valueOf() : undefined
        data.endTime = checkedEndDatetime && endDateTime && data.endTime !== null ?
          endDateTime.valueOf() - data.endDate : undefined

        delete data.authorType

        return new Promise((resolve, reject) => {
          if (before.thumbnail !== after.thumbnail) {
            if (after.thumbnail === '' || after.thumbnail === undefined) {
              resolve({ result: true, photoURL: '' })
            }
            dispatch(api.media.upload(
              'thumbnail',
              '#thumbnailUrl',
              (response) => {
                if (response.result === true) {
                  resolve(response)
                }
                else {
                  reject('faild to upload thumbnail.')
                }
              }
            ))
          }
          else {
            resolve(null)
          }
        })
        .then(response => {
          if (response === null) {
            data.thumbnail = before.thumbnail
          }
          else if (response.result === true) {
            data.thumbnail = response.photoURL
          }
          else {
            data.thumbnail = before.thumbnail
            dispatch(actions.snackbar.notify(<Word wid={WID.EVENT_REGISTER_CARD.SNACKBAR_FAILED_UPLOAD_THUMBNAIL}/>, 'error'))
            return Promise.resolve({})
          }
          return dispatch(api.event.update(parseInt(ownProps.match.params.eventId, 10), data))
        })
        .then(response => {
          if (response.result === true) {
            dispatch(actions.snackbar.notify(<Word wid={WID.EVENT_REGISTER_CARD.SNACKBAR_SUCCESS_UPDATE}/>, 'info'))
            return Promise.resolve({ result: EVENT_REGISTER_RESULT.SUCCESS, eventId: response.id })
          }
          else {
            dispatch(actions.snackbar.notify(<Word wid={WID.EVENT_REGISTER_CARD.SNACKBAR_FAILED_UPDATE}/>, 'error'))
            return Promise.reject('error')
          }
        })
      },
    }
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EventRegister)



// WEBPACK FOOTER //
// ./src/Pages/Event/containers/EventRegister.js